import React, {useContext, useRef, useState} from "react";
import MessagesListContainer from "./MessagesListContainer";
import FilterMessages from "../../components/Message/FilterMessages";
import SendMessageForm from "../../components/Message/SendMessageForm";
import Context from "../../context/Message";

export default ({comet, uiTab, position, messageLimit, episode, currentStream, currentRoom}) => {
    const {
        messageTargets,
        createMessage,
        toggleClientSettings,
    } = useContext(Context);
    const [filter, setFilter] = useState('event');
    const gradientRef = useRef(null);

    const gradientToggle = (show) => {
        if (!gradientRef.current) {
            return;
        }
        if (show) {
            gradientRef.current.classList.add('show');
        } else {
            gradientRef.current.classList.remove('show');
        }
    }

    return (
        <div className="messagesContainer">
            <MessagesListContainer
                comet={comet}
                uiTab={uiTab}
                position={position}
                messageLimit={messageLimit}
                episode={episode}
                currentStream={currentStream}
                currentRoom={currentRoom}
                onGradientToggle={gradientToggle}
                filter={filter}
            />
            <div className="messageControlsContainer">
                <div className="messageGradientFadeout" ref={gradientRef} />
                <FilterMessages filter={filter} setFilter={setFilter} />
                <SendMessageForm
                    onClickNickname={toggleClientSettings}
                    messageTargets={messageTargets}
                    onSubmit={createMessage}
                />
            </div>
        </div>
    );
};
